import { Modal } from 'components';
import {
  Close as CloseIcon,
  Check as CheckIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

export const ModalForm = ({ children, handleAccept, acceptLabel, cancelLabel, handleCancel, open, isLoading, maxWidth, disableAcceptButton }) => {
  return (
    <Modal
      actions={[
        {
          color: 'error',
          icon: <CloseIcon />,
          label: cancelLabel,
          fn: () => handleCancel(),
          disabled: isLoading,
          hidden: !handleCancel,
        },
        {
          color: 'primary',
          icon: <CheckIcon />,
          label: acceptLabel,
          fn: () => handleAccept(),
          disabled: isLoading || disableAcceptButton,
          processing: isLoading,
          hidden: !handleAccept,
        },
      ]}
      maxWidth={maxWidth}
      open={open}
    >
      {children}
    </Modal>
  );
};

ModalForm.propTypes = {
  children: PropTypes.node,
  handleAccept: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  maxWidth: PropTypes.oneOf([
    'lg',
    'md',
    'sm',
    'xl',
    'xs',
  ]),
  acceptLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  disableAcceptButton: PropTypes.bool,
};

ModalForm.defaultProps = {
  maxWidth: 'md',
  acceptLabel: 'Aceptar',
  cancelLabel: 'Cancelar',
};
